import { render } from "./TopicsManager.vue?vue&type=template&id=6b2ae1d0&scoped=true"
import script from "./TopicsManager.vue?vue&type=script&lang=js"
export * from "./TopicsManager.vue?vue&type=script&lang=js"

import "./TopicsManager.vue?vue&type=style&index=0&id=6b2ae1d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2ae1d0"]])

export default __exports__